<template>
  <div class="on-off" :class="{on: turnedOn}" v-on:click="toggle"></div>
</template>

<script>
export default {
  props:{
    value: Boolean
  },
  data () {
    return {
      turnedOn: false
    }
  },
  created () {
    this.turnedOn = this.value
  },
  methods: {
    toggle: function () {
      this.turnedOn = !this.turnedOn
      this.$emit('input', this.turnedOn)
    }
  },
  watch: {
    value: function () {
      this.turnedOn = this.value
    }
  }
}
</script>

<style scoped>
.on-off{
  display:inline-block;
  width:30px;
  height:16px;
  background-image:url('../../assets/img/off.svg');
  background-repeat: no-repeat;
  background-size:contain;
  cursor: pointer;
  background-position: center center;
}

.on-off.on{
  background-image:url('../../assets/img/on.svg')
}
</style>
